import { observer } from 'mobx-react'
import React, { useEffect, useState } from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import EvaluationInfoComponent from '../../../components/CRM/ExpertCRM/EvaluationInfo/EvaluationInfo.component'

import { getEvaluationInfo } from '../../../services/expert/expertEvaluation.service'
import { evaluationInfoGetStore } from '../../../store/ExpertStore/ExpertEvaluation.store'

const EvaluationInfoContainer = (props: RouteComponentProps): JSX.Element => (
    <EvaluationInfoComponent 
      data={evaluationInfoGetStore.evaluationInfo}
      isLoading={evaluationInfoGetStore.isLoading}
    />
  )

export default withRouter(observer(EvaluationInfoContainer))